import {AfterViewInit, Directive, ElementRef, EventEmitter, Input, Output} from "@angular/core";

export class ProtrusionSpec {
    protrusion: number;
    class: string;
}

@Directive({
    selector: "[woa-sticky]"
})
/**
 * Directive to add a class or classes to a sticky element as it approaches the edge of the viewport
 */
export class StickyDirective implements AfterViewInit {
    @Input() topMargin: number = 1;
    @Input() increments: number = 10;
    @Input() classes: [ProtrusionSpec] = [{protrusion: 0, class: "stuck"}];
    @Input() minHeight: number = 0;
    @Input() delay: number = 0;

    @Output() onStuckChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor(private element: ElementRef) {
    }

    ngAfterViewInit(): void {
        setTimeout(() => this.initHeight());
        setTimeout(() => new IntersectionObserver(
            ([entry]: [IntersectionObserverEntry]) => {
                const protrusion: number = entry.intersectionRect.top - entry.boundingClientRect.top;
                this.classes.forEach((spec: ProtrusionSpec) => entry.target.classList.toggle(spec.class, protrusion > spec.protrusion));
                this.onStuckChange.emit(protrusion > this.classes[0].protrusion);
            },
            {
                rootMargin: "-" + this.topMargin + "px 0px 0px 0px",
                threshold: Array.from({length: this.increments + 1}, (_, i) => i / this.increments)
            }
        ).observe(this.element.nativeElement), this.delay);
    }

    private initHeight(): void {
        this.element.nativeElement.style.minHeight = Math.max(this.element.nativeElement.getBoundingClientRect().height, this.minHeight) + "px";
        this.element.nativeElement.style.maxHeight = this.element.nativeElement.style.minHeight;
    }
}



// WEBPACK FOOTER //
// ./src/app/ui-elements/sticky.directive.ts